import styled from '@emotion/styled'
import { Hero } from 'app/components/Hero'
import { SEO } from 'app/components/SEO'
import {
  Props as StructuredDataProps,
  StructuredData,
} from 'app/components/StructuredData'
import { ApplicationForm } from 'app/containers/ApplicationForm'
import { Footer, Props as FooterProps } from 'app/containers/Footer'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import {
  ApplicationFormSenderBackend,
  ApplicationFormSenderBackendConfiguration,
} from 'app/utils/ApplicationFormSender'
import { PageProps } from 'gatsby'
import React, { memo, useMemo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
  applicationFormSenderBackendConfiguration: ApplicationFormSenderBackendConfiguration
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function WorksPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  const sendFormToBackend = useMemo(
    () =>
      ApplicationFormSenderBackend(
        pageContext.applicationFormSenderBackendConfiguration,
      ),
    [pageContext.applicationFormSenderBackendConfiguration],
  )

  return (
    <Container>
      <SEO {...context.seoProps} />
      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
      {context.headerProps ? (
        <Header
          pageID={context.id}
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          {...context.headerProps}
        />
      ) : null}
      {context.heroProps ? <Hero {...context.heroProps} /> : null}
      {context.formProps ? (
        <ApplicationForm
          {...context.formProps}
          onApplicationFormSendToBackend={async (data) =>
            await sendFormToBackend(data)
          }
        />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}
    </Container>
  )
})

const Container = styled.main`
  @media (max-width: 1023px) {
    .newsletter {
      display: none;
    }
  }
`
